import React, { memo, Fragment } from 'react';
import { Col, Row, Card, CardBody, Badge } from 'reactstrap';
import { DealProposalResponse } from '@business/entities/deal';
import { ProposalService, CommonService } from '@business/services';
import { R } from '@core/utils/r';
import { ProposalId } from '@business/entities/proposal';
import { Formatter } from '@core/utils/formatter';
import { useCompany } from '@core/utils/hooks/misc';

export interface DealProposalItemProps {
  proposal: DealProposalResponse;
  onDelete(id: ProposalId): void;
}

const DealProposalItem = memo((props: DealProposalItemProps) => {
  const { proposal, onDelete } = props;
  const company = useCompany();
  return (
    <Col lg={3}>
      <Card>
        <CardBody className="d-flex align-items-center">
          <div className="d-flex flex-row mt-2 mb-2 align-items-center">
            <div className="float-right ml-2" style={{ position: 'absolute', top: 10, right: 5 }}>
              <a
                className="text-danger"
                onClick={e => {
                  onDelete(proposal.id);
                  e.stopPropagation();
                }}
              >
                <i className="bx bx-trash font-size-16 text-danger"></i>
              </a>
            </div>
            <div style={{ position: 'relative' }}>
              <img
                style={{
                  width: 60,
                  height: 80,
                  objectFit: 'cover',
                  objectPosition: 'top',
                  borderRadius: 10,
                }}
                src={proposal.image}
              />
              <Badge
                className="d-flex flex-row p-1 align-items-center text-center"
                style={{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  right: 0,
                  fontSize: 10,
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  borderBottomLeftRadius: 10,
                  borderBottomRightRadius: 10,
                  justifyContent: 'center',
                }}
                color={ProposalService.getStatusColor(proposal.status)}
              >
                {R.upperFirst(proposal.status)}
              </Badge>
            </div>
            <div className="d-flex flex-column ml-4">
              <span className={`text-dark font-weight-medium font-size-16`}>{proposal.title}</span>
              <span className="text-muted font-size-12">Created By: {CommonService.getFullName(proposal.createdBy)}</span>
              <span className="text-muted font-size-12">Total: {Formatter.formatCurrency(proposal.amount, company.currencyCode)}</span>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
});

export interface DealProposalsProps {
  proposals: DealProposalResponse[];
  onDelete(id: ProposalId): void;
}

export const DealProposals = memo((props: DealProposalsProps) => {
  const { proposals, onDelete } = props;
  return (
    <Fragment>
      {proposals.map(p => (
        <DealProposalItem proposal={p} key={p.id} onDelete={onDelete} />
      ))}
    </Fragment>
  );
});
